export const moveRoom = rid => ({
  type: '@risa/MOVEROOM',
  rid: rid
})

export default moveRoom
